import type { InventoryInformationView } from "@slfinrtl/ui-bff-routes"
import { defineMessages, useIntl } from "react-intl"
import { emptyPlaceholder } from "src/common/emptyPlaceholder"
import { Flex, List } from "src/components"
import type { VehicleDetailsStage } from "src/screens/vehicleDetails/common/VehicleDetailsStage"
import { EditButton } from "../editButton/EditButton"

const messages = defineMessages({
	accidentFree: {
		defaultMessage: "Accident free",
		id: "vehicle.condition.accidentFree",
	},
	conditionTitle: {
		defaultMessage: "Condition",
		id: "vehicleDetails.overview.summary.conditionTitle",
	},
	firstRegistration: {
		defaultMessage: "First Registration",
		id: "vehicleDetails.overview.summary.firstRegistration",
	},
	knownAccidentsLabel: {
		defaultMessage: "Known previous damages or accidents",
		id: "vehicle.condition.knownAccidents",
	},
	mileage: {
		defaultMessage: "Mileage",
		id: "vehicleDetails.overview.summary.mileage",
	},
	numberPreOwners: {
		defaultMessage: "No. of previous owners",
		id: "vehicleDetails.overview.summary.numberPreOwners",
	},
	previousOwnerUsageHistory: {
		defaultMessage: "Previous owner usage history",
		id: "conditionAndHistory.previousOwnerUsageHistory.label",
	},
	vehicleType: {
		defaultMessage: "Vehicle type",
		id: "vehicleDetails.overview.summary.vehicleType",
	},
})

interface ConditionListProps {
	onEditClick: (stage: VehicleDetailsStage) => void
	view: InventoryInformationView | null
}
export const ConditionList = ({ onEditClick, view }: ConditionListProps) => {
	const { formatMessage } = useIntl()
	return (
		<List header={formatMessage(messages.conditionTitle)}>
			<List.Item
				label={formatMessage(messages.vehicleType)}
				value={
					<Flex $gap="xs">
						<List.ItemValue value={view?.inventoryAndIntake.vehicleType ?? emptyPlaceholder} />
						{view?.inventoryAndIntake.inventoryEdit && (
							<EditButton
								onClick={() => onEditClick("inventoryIntake")}
								actionItem={view.inventoryAndIntake.inventoryEdit}
							/>
						)}
					</Flex>
				}
				valueSingleLine
			/>
			{view?.conditionAndService.firstRegistration && (
				<List.Item
					label={formatMessage(messages.firstRegistration)}
					value={view.conditionAndService.firstRegistration}
					valueSingleLine
				/>
			)}

			<List.Item
				label={formatMessage(messages.mileage)}
				value={
					<Flex $gap="xs">
						<List.ItemValue value={view?.conditionAndService.mileage ?? emptyPlaceholder} />
						{view?.conditionAndService.historyEdit && (
							<EditButton
								onClick={() => onEditClick("conditionService")}
								actionItem={view.conditionAndService.historyEdit}
							/>
						)}
					</Flex>
				}
				valueSingleLine
			/>
			<List.Item
				label={formatMessage(messages.numberPreOwners)}
				value={view?.conditionAndService.numberOfPreviousOwners ?? emptyPlaceholder}
				valueSingleLine
			/>
			{view?.conditionAndService.previousOwnerUsageHistory && (
				<List.Item
					label={formatMessage(messages.previousOwnerUsageHistory)}
					value={view.conditionAndService.previousOwnerUsageHistory}
					valueSingleLine
				/>
			)}
			{view?.conditionAndService.accidentFree && (
				<List.Item
					label={formatMessage(messages.accidentFree)}
					labelSingleLine
					value={view.conditionAndService.accidentFree}
					valueSingleLine
				/>
			)}
			{view?.conditionAndService.knownAccidents && (
				<List.Item
					label={formatMessage(messages.knownAccidentsLabel)}
					labelSingleLine
					value={view.conditionAndService.knownAccidents}
					valueSingleLine
				/>
			)}
		</List>
	)
}
